import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';

export const OrderDetailModal = ({ data, onClose }) => (
  <div
    className="fixed inset-0 bg-charcoal-ink/60 z-50 flex items-center justify-center p-4"
    onClick={onClose}
  >
    <Card className="w-full max-w-3xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
      <CardHeader>
        <CardTitle>Order {data.order.orderNumber}</CardTitle>
        <CardDescription>{data.order.customerInfo?.name} • {data.order.customerInfo?.email}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <p className="font-semibold mb-2">Items</p>
          {data.order.items?.map((i, idx) => (
            <div key={idx} className="text-sm border-b border-stone-taupe/10 py-2">
              <div className="flex justify-between">
                <span>{i.name} ({i.priceType}) × {i.quantity}</span>
                <span>${(i.price * i.quantity).toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>
        {data.designDetails ? (
          <div className="bg-soft-linen p-4 rounded-md text-sm space-y-1">
            <p className="font-semibold">Design Details</p>
            <p><strong>Theme:</strong> {data.designDetails.theme}</p>
            <p><strong>Colors:</strong> {data.designDetails.colors}</p>
            <p><strong>Style:</strong> {data.designDetails.style}</p>
            <p><strong>Names:</strong> {data.designDetails.exactNames}</p>
            <p><strong>Phrasing:</strong> {data.designDetails.exactPhrasing}</p>
            {data.designDetails.shippingAddress && (
              <p><strong>Shipping:</strong> {data.designDetails.shippingAddress}</p>
            )}
            {data.designDetails.favorItemChoice && (
              <p><strong>Favor choice:</strong> {data.designDetails.favorItemChoice}</p>
            )}
          </div>
        ) : (
          <p className="text-stone-taupe text-sm italic">Customer hasn't submitted design details yet.</p>
        )}
        <Button variant="outline" onClick={onClose}>Close</Button>
      </CardContent>
    </Card>
  </div>
);
